import { useQuery } from '@tanstack/react-query';

import { personaResearchHistoryQuery } from '../api/gwi-research.api';
import type { GwiResearchCategory } from '../api/query-keys';

export const usePersonaResearchHistory = (
  personaId: string | null | undefined,
  category?: GwiResearchCategory,
  enabled = true,
) => {
  return useQuery({
    ...personaResearchHistoryQuery(personaId, category),
    enabled: enabled && !!personaId,
  });
};
